export default "__VITE_ASSET__BIag7MM8__"